import { mdlAgencyMarketListRequest } from "../models/service-models/agency-market/AgencyMarketListRequest";
import { mdlAgencyMarketListResponse } from "../models/service-models/agency-market/AgencyMarketListResponse";
import { mdlAgencyMarketUpdateRequest } from "../models/service-models/agency-market/AgencyMarketUpdateRequest";
import { mdlAgencyMarketUpdateResponse } from "../models/service-models/agency-market/AgencyMarketUpdateResponse";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { GetResponse } from "../utils/ApiClient";

namespace AgencyMarketService {
    export async function List(
        pRequest: mdlAgencyMarketListRequest
    ): Promise<mdlServiceResponse<mdlAgencyMarketListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlAgencyMarketListResponse>>(
            "agencymarket/list",
            pRequest
        );
    }
    export async function HotelAgencyList(
        pRequest: mdlAgencyMarketListRequest
    ): Promise<mdlServiceResponse<mdlAgencyMarketListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlAgencyMarketListResponse>>(
            "agencymarket/hotel-agency-list",
            pRequest
        );
    }

    export async function Update(
        pRequest: mdlAgencyMarketUpdateRequest
    ): Promise<mdlServiceResponse<mdlAgencyMarketUpdateResponse>> {
        return await GetResponse<mdlServiceResponse<mdlAgencyMarketUpdateResponse>>(
            "agencymarket/update",
            pRequest
        );
    }
}
export { AgencyMarketService };
